import { useEffect, useMemo } from 'react'
import { Grid } from 'semantic-ui-react'

import { useFormFlow, useSetScreen } from '@/componentsV1/FormFlow/formFlow'
import PageHeader from '@/shared/PageHeader'
import { GridRowColumn } from '@/base'
import GoalSettingIntro from '@/featuresV1/GoalSetting/GoalSettingIntro'
import SettingFinancialGoals from '@/featuresV1/GoalSetting/SettingFinancialGoals'
import { useAppDispatch } from '@/utils/typeHelpers'
import { fetchUserTransactions } from '../Transactions/transactions.slice'

export enum GOAL_SETTING_SCREENS {
  intro = 'intro',
  setGoals = 'setGoals',
}

const GoalSetting = () => {
  const dispatch = useAppDispatch()
  const backLink = '/'
  const { setScreen, currentScreen } = useSetScreen({
    backLink,
  })

  const screenConfig = useMemo(() => {
    const props = { goBack: setScreen }
    return [
      {
        component: () => (
          <GoalSettingIntro
            {...props}
            goToNextStep={() => setScreen(GOAL_SETTING_SCREENS.setGoals)}
          />
        ),
        screenName: GOAL_SETTING_SCREENS.intro,
        step: 0,
      },
      {
        component: () => <SettingFinancialGoals {...props} />,
        screenName: GOAL_SETTING_SCREENS.setGoals,
        step: 1,
      },
    ]
  }, [setScreen])

  useEffect(() => {
    dispatch(fetchUserTransactions(true))
  }, [dispatch])

  useEffect(() => {
    if (!currentScreen) {
      setScreen(GOAL_SETTING_SCREENS.intro, true)
    }
  }, [setScreen, currentScreen])

  const { content } = useFormFlow({
    steps: [],
    screens: screenConfig,
  })

  return (
    <>
      <PageHeader
        backControl={{ link: backLink, text: 'Back to Home' }}
        header=""
      />
      <Grid>
        <GridRowColumn>{content}</GridRowColumn>
      </Grid>
    </>
  )
}

export default GoalSetting
